import avisoInscricao from 'assets/img/2026/ELBB/aviso_inscricao.png';
import naveEspacial from 'assets/img/2026/ELBB/cubo_foguete.png';
import trofeuEtapa3 from 'assets/img/2026/trofeu_etapa3_full.png';
import { OnboardingModal } from 'components/OnboardingModal';
import { VotacaoEtapa1TutorialModal } from 'components/VotacaoEtapa1TutorialModal';
import { VotacaoEtapa2TutorialModal } from 'components/VotacaoEtapa2TutorialModal';
import { VotacaoEtapa3TutorialModal } from 'components/VotacaoEtapa3TutorialModal';
import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext/Modal.context';
import { useControlDate, useIsDateActive } from 'hooks/useControlDate';
import { useCallback, useEffect, useMemo, useRef, useState, type MouseEvent } from 'react';
import { IoArrowForward } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { fetchMinhasAvaliacoesEtapa2 } from 'services/avaliacao-etapa2.service';
import { invalidateCache } from 'services/cache';
import { fetchChallengesWithStatus } from 'services/challenge.service';
import { buscarComunicados } from 'services/comunicado.service';
import { buscarIniciativas, buscarIniciativasPorPlayer } from 'services/iniciativa.service';
import { fetchCategoriasCompletadas } from 'services/selecao-etapa1.service';
import { fetchTodasSelecoesByUser } from 'services/selecao-etapa3.service';
import { getAllTutorials, getTutorial, getTutorialByTitle } from 'services/tutorial.service';
import {
  buscarValidacaoEtapa1PorPrefixo,
  getIdentifierFromPlayerFields,
  hasEtapa1Eligibility,
} from 'services/validacao-etapa1.service';
import {
  fetchPreliminarEmAprovacaoByVp,
  fetchUltimoPreliminarByAssessor,
} from 'services/voto-preliminar-etapa3.service';
import {
  getTutorialEtapa3IdForUser,
  isAssessorEtapa3,
  isVpEtapa3,
} from 'types/etapa3';
import { Tutorial } from 'types/tutorial';
import { PHASE_IDS } from 'utils/constants';
import { clearRegistrationUser } from 'utils/fns';
import { normalizeCategoryPremio } from 'utils/iniciativa-categoria';
import {
  CategoriasParticipantes,
  // GaleriaPremioElbb, // Galeria desativada temporariamente (não usada no momento)
  HeaderElbb,
  HeroElbb,
  PodioElbb,
  PremiacoesSectionElbb,
  PremiadosBannerElbb,
} from './components';
import {
  CATEGORIAS_PARTICIPANTES_ETAPA3,
  isPreliminarElbb,
} from './components/CategoriasParticipantesEtapa3';
import './style.scss';
import { filterChallengesByJourneyProfile } from './utils/journeyChallenges';

const CHALLENGE_ID_VOTAR_INICIATIVAS = 'FohR25H';
const CHALLENGE_TITULO_VOTAR_INICIATIVAS = 'Vote nas iniciativas';

const normalizeMatricula = (value?: string | null) => clearRegistrationUser(String(value || ''));

const isUsuarioConfirmadoNaIniciativaElbb = (ini: any, currentUserRegistration: string) => {
  if (!currentUserRegistration) {
    return false;
  }

  const participanteAtual = Array.isArray(ini?.participantes)
    ? ini.participantes.find(
        (participante: any) =>
          normalizeMatricula(participante?.matricula) === currentUserRegistration
      )
    : undefined;

  const isParticipanteConfirmadoNoModal = Boolean(participanteAtual?.confirmado);

  const isConfirmadoEmConfirmedPlayers = Array.isArray(ini?.confirmedPlayers)
    ? ini.confirmedPlayers.some(
        (confirmedPlayerId: string) =>
          normalizeMatricula(confirmedPlayerId) === currentUserRegistration
      )
    : false;

  return isParticipanteConfirmadoNoModal || isConfirmadoEmConfirmedPlayers;
};

export function HomeElbb() {
  const { user, tutorial: contextTutorial } = useAuth();
  const isRegistrationPeriodActive = useIsDateActive(PHASE_IDS.ELBB_REGISTRATION_PERIOD);
  const isEtapaUmVotacaoAtiva = useIsDateActive(PHASE_IDS.ELBB_VOTING_STAGE1);
  const isEtapaDoisVotacaoAtiva = useIsDateActive(PHASE_IDS.ETAPA_2_PREMIO);
  const isEtapaTresVotacaoAtiva = useIsDateActive(PHASE_IDS.ETAPA_3_PREMIO);
  const isElegivelEtapa1 = hasEtapa1Eligibility(user?.detail);
  const controlDateEtapa2 = useControlDate(PHASE_IDS.ETAPA_2_PREMIO);
  const datasEtapa2Label = useMemo(() => {
    if (!controlDateEtapa2?.dataInicio || !controlDateEtapa2?.dataFim) return '';
    const fmt = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' });
    const inicio = fmt.format(new Date(controlDateEtapa2.dataInicio));
    const fim = fmt.format(new Date(controlDateEtapa2.dataFim));
    return `${inicio} a ${fim}`;
  }, [controlDateEtapa2]);
  const navigate = useNavigate();
  const { showModal, closeModal } = useModal();
  const [badges, setBadges] = useState<any[]>([]);
  const [hasConquistaVotar, setHasConquistaVotar] = useState(false);
  const [iniciativas, setIniciativas] = useState<any[]>([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>('todos');
  const [comunicados, setComunicados] = useState<any[]>([]);
  const [stepAtivo, setStepAtivo] = useState(0);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);
  const [tutorial, setTutorial] = useState<Tutorial | null>(contextTutorial || null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [loadingBadges, setLoadingBadges] = useState(true);
  const [loadingIniciativas, setLoadingIniciativas] = useState(true);
  const [loadingComunicados, setLoadingComunicados] = useState(true);
  const [temIniciativasPlayer, setTemIniciativasPlayer] = useState(false);
  const [temIniciativasParaConfirmar, setTemIniciativasParaConfirmar] = useState(false);
  const [isParticipanteConfirmado, setIsParticipanteConfirmado] = useState(false);
  const [todasCategoriasEtapa1Completas, setTodasCategoriasEtapa1Completas] = useState(false);
  const [temIniciativasEtapa1, setTemIniciativasEtapa1] = useState(false);
  const [tutorialEtapa1, setTutorialEtapa1] = useState<Tutorial | null>(null);
  const [tutorialEtapa2, setTutorialEtapa2] = useState<Tutorial | null>(null);
  const [jaVotouTodasCategoriasEtapa2, setJaVotouTodasCategoriasEtapa2] = useState(false);
  const [tutorialEtapa3, setTutorialEtapa3] = useState<Tutorial | null>(null);
  const [jaVotouTodasCategoriasEtapa3, setJaVotouTodasCategoriasEtapa3] = useState(false);
  const [temVotoEtapa3Submetido, setTemVotoEtapa3Submetido] = useState(false);
  const [assessorEnviouPreliminar, setAssessorEnviouPreliminar] = useState(false);
  const [assessorPreliminarSuperseded, setAssessorPreliminarSuperseded] = useState(false);
  const [vpTemPreliminarPendente, setVpTemPreliminarPendente] = useState(false);
  const [extratoPopupOpen, setExtratoPopupOpen] = useState(true);

  const isAssessor = isAssessorEtapa3(user ?? null);
  const isVp = isVpEtapa3(user ?? null);
  const assessorJaEnviou =
    isAssessor && (assessorEnviouPreliminar || assessorPreliminarSuperseded);

  const loadBadges = useCallback(async () => {
    if (!user?._id) return;

    try {
      setLoadingBadges(true);
      invalidateCache(`player-challenges-${user._id}`);

      const challengesData = await fetchChallengesWithStatus(user._id);
      const filteredChallenges = filterChallengesByJourneyProfile(challengesData, user?.extra);

      const conquistouVotar = filteredChallenges.some(
        (challenge) =>
          challenge.concluida &&
          (challenge.id === CHALLENGE_ID_VOTAR_INICIATIVAS ||
            challenge.titulo === CHALLENGE_TITULO_VOTAR_INICIATIVAS)
      );
      setHasConquistaVotar(conquistouVotar);

      const sortedChallenges = [...filteredChallenges].sort((a, b) => {
        if (a.concluida && !b.concluida) return -1;
        if (!a.concluida && b.concluida) return 1;
        return 0;
      });

      const badgesData = sortedChallenges.slice(0, 5).map(challenge => ({
        id: challenge.id,
        nome: challenge.titulo,
        imagem: challenge.icone,
        conquistado: challenge.concluida
      }));

      setBadges(badgesData);
    } catch (error) {
      console.error('Erro ao carregar badges:', error);
      setHasConquistaVotar(false);
    } finally {
      setLoadingBadges(false);
    }
  }, [user?._id, user?.extra]);

  useEffect(() => {
    loadBadges();
  }, [loadBadges, user?.extra?.habilitado, user?.extra?.is_manager]);

  useEffect(() => {
    const handleActionLogCompleted = () => {
      loadBadges();
    };

    window.addEventListener('action-log:completed', handleActionLogCompleted);

    return () => {
      window.removeEventListener('action-log:completed', handleActionLogCompleted);
    };
  }, [loadBadges]);

  useEffect(() => {
    async function carregarIniciativas() {
      try {
        setLoadingIniciativas(true);
        const data = await buscarIniciativas();
        const inscritas = (data || []).filter((ini: any) => ini.status === 'inscrita');
        setIniciativas(inscritas);
      } catch (error) {
        setIniciativas([]);
      } finally {
        setLoadingIniciativas(false);
      }
    }

    if (user?._id) {
      carregarIniciativas();
    }
  }, [user?._id]);

  const iniciativasFiltradas = useMemo(() => {
    if (categoriaSelecionada === 'todos') {
      return iniciativas.slice(0, 3);
    }

    return iniciativas
      .filter((ini: any) => normalizeCategoryPremio(ini.categoryPremio) === categoriaSelecionada)
      .slice(0, 3);
  }, [iniciativas, categoriaSelecionada]);

  useEffect(() => {
    async function carregarComunicados() {
      try {
        setLoadingComunicados(true);
        const data = await buscarComunicados();
        const elbbComunicados = (data || []).filter((c: any) => c.titulo === 'ELBB');
        setComunicados(elbbComunicados);
      } catch (error) {
        console.error('Erro ao carregar comunicados:', error);
        setComunicados([]);
      } finally {
        setLoadingComunicados(false);
      }
    }

    carregarComunicados();
  }, []);

  useEffect(() => {
    if (!user?._id) return;
    async function verificarIniciativasPlayer() {
      try {
        const data = await buscarIniciativasPorPlayer(user!._id);
        const iniciativasElbb = data.filter((ini) => ini.categoryPremio === 'ELBB');
        const currentUserRegistration = normalizeMatricula(user?._id);

        const confirmadoEmAlgumaIniciativa = iniciativasElbb.some((ini: any) =>
          isUsuarioConfirmadoNaIniciativaElbb(ini, currentUserRegistration)
        );

        const possuiPendenciaInscricaoOuConfirmacao = iniciativasElbb.some((ini: any) => {
          const status = String(ini?.status || '').toLowerCase();
          const jaConfirmadoNessaIniciativa = isUsuarioConfirmadoNaIniciativaElbb(
            ini,
            currentUserRegistration
          );

          const precisaInscrever = status !== 'inscrita' && isRegistrationPeriodActive;
          const precisaConfirmarParticipacao = status === 'inscrita' && !jaConfirmadoNessaIniciativa;

          return precisaInscrever || precisaConfirmarParticipacao;
        });

        const soConfirmacaoPendente = iniciativasElbb.some((ini: any) => {
          const status = String(ini?.status || '').toLowerCase();
          const jaConfirmado = isUsuarioConfirmadoNaIniciativaElbb(ini, currentUserRegistration);
          return status === 'inscrita' && !jaConfirmado;
        });

        setTemIniciativasPlayer(possuiPendenciaInscricaoOuConfirmacao);
        setTemIniciativasParaConfirmar(soConfirmacaoPendente);
        setIsParticipanteConfirmado(confirmadoEmAlgumaIniciativa);
      } catch {
        setTemIniciativasPlayer(false);
        setIsParticipanteConfirmado(false);
      }
    }
    verificarIniciativasPlayer();
  }, [user?._id, isRegistrationPeriodActive]);

  useEffect(() => {
    async function loadTutorial() {
      try {
        const [tutorials, tutorialEtapa1Api] = await Promise.all([
          getAllTutorials(),
          getTutorialByTitle('TUTORIAL_ETAPA1'),
        ]);
        if (tutorials && tutorials.length > 0) {
          const elbbTutorial = tutorials.find(t => t.title === 'ELBB') ?? tutorials[0];
          setTutorial(elbbTutorial);
        }
        if (tutorialEtapa1Api) {
          setTutorialEtapa1(tutorialEtapa1Api);
        }
      } catch (error) {
        console.error('Erro ao carregar tutorial:', error);
      }
    }

    loadTutorial();
  }, []);

  useEffect(() => {
    let canceled = false;
    if (user?.extra?.etapa !== 2) return;
    getTutorialByTitle('TUTORIAL_ETAPA2')
      .then((t) => { if (!canceled) setTutorialEtapa2(t); })
      .catch(() => { if (!canceled) setTutorialEtapa2(null); });
    return () => { canceled = true; };
  }, [user?.extra?.etapa]);

  useEffect(() => {
    let canceled = false;
    const categorias = (user?.extra?.categories ?? []) as string[];
    if (!user?._id || user.extra?.etapa !== 2 || categorias.length === 0) {
      setJaVotouTodasCategoriasEtapa2(false);
      return;
    }
    fetchMinhasAvaliacoesEtapa2(user._id)
      .then((avaliacoes) => {
        if (canceled) return;
        const votadas = new Set(avaliacoes.map((a) => a.category));
        setJaVotouTodasCategoriasEtapa2(categorias.every((c: string) => votadas.has(c)));
      })
      .catch(() => { if (!canceled) setJaVotouTodasCategoriasEtapa2(false); });
    return () => { canceled = true; };
  }, [user?._id, user?.extra?.etapa, user?.extra?.categories]);

  // Etapa 3 — tutorial
  useEffect(() => {
    let canceled = false;
    if (!user?._id) return;
    getTutorial(getTutorialEtapa3IdForUser(user))
      .then((t) => { if (!canceled) setTutorialEtapa3(t ?? null); })
      .catch(() => { if (!canceled) setTutorialEtapa3(null); });
    return () => { canceled = true; };
  }, [user?._id]);

  // Etapa 3 — verifica seleções submetidas
  useEffect(() => {
    let canceled = false;
    if (!user?._id) return;
    fetchTodasSelecoesByUser(user._id)
      .then((selecoes) => {
        if (canceled) return;
        const idsElbb = new Set(CATEGORIAS_PARTICIPANTES_ETAPA3.map((c) => c.id));
        // Considera apenas selecoes da categoria ELBB com pelo menos 1 iniciativa.
        // Um registro com iniciativaIds vazio (usuário votou e depois desmarcou)
        // não deve contar como "tem voto submetido".
        const selecoesElbb = selecoes.filter(
          (s) => idsElbb.has(s.categoria) && (s.iniciativaIds?.length ?? 0) > 0
        );
        if (selecoesElbb.length === 0) {
          setTemVotoEtapa3Submetido(false);
          setJaVotouTodasCategoriasEtapa3(false);
          return;
        }
        setTemVotoEtapa3Submetido(true);
        const categoriasVotadas = new Set(selecoesElbb.map((s) => s.categoria));
        const todasCompletas = CATEGORIAS_PARTICIPANTES_ETAPA3.every((c) =>
          categoriasVotadas.has(c.id)
        );
        setJaVotouTodasCategoriasEtapa3(todasCompletas);
      })
      .catch(() => {
        if (!canceled) {
          setTemVotoEtapa3Submetido(false);
          setJaVotouTodasCategoriasEtapa3(false);
        }
      });
    return () => { canceled = true; };
  }, [user?._id]);

  // Etapa 3 — voto preliminar (assessor / VP)
  useEffect(() => {
    let canceled = false;
    if (!user?._id) {
      setAssessorEnviouPreliminar(false);
      setAssessorPreliminarSuperseded(false);
      setVpTemPreliminarPendente(false);
      return;
    }
    if (isAssessor) {
      fetchUltimoPreliminarByAssessor(user._id)
        .then((p) => {
          if (canceled) return;
          // voto_preliminar_etapa3__c é compartilhado com a Conexão — só conta
          // se o preliminar pertencer ao produto ELBB.
          const pElbb = isPreliminarElbb(p?.notasRascunho) ? p : null;
          setAssessorEnviouPreliminar(
            pElbb?.status === 'em_aprovacao' && !pElbb?.supersededAt
          );
          setAssessorPreliminarSuperseded(!!pElbb?.supersededAt);
        })
        .catch(() => {
          if (canceled) return;
          setAssessorEnviouPreliminar(false);
          setAssessorPreliminarSuperseded(false);
        });
    } else if (isVp) {
      fetchPreliminarEmAprovacaoByVp(user._id, isPreliminarElbb)
        .then((p) => {
          if (!canceled) setVpTemPreliminarPendente(!!p);
        })
        .catch(() => {
          if (!canceled) setVpTemPreliminarPendente(false);
        });
    }
    return () => {
      canceled = true;
    };
  }, [user?._id, isAssessor, isVp]);

  useEffect(() => {
    async function checkEtapa1Completion() {
      if (!isElegivelEtapa1 || !user?.detail) return;
      const identifier = getIdentifierFromPlayerFields(user.detail);
      if (!identifier.comite && !identifier.prefixo) return;
      try {
        const etapa1 = (user.detail.etapa1 || []) as string[];
        const completadas = await fetchCategoriasCompletadas(identifier, etapa1);
        setTodasCategoriasEtapa1Completas(completadas.length >= etapa1.length);

        const iniciativas = await buscarValidacaoEtapa1PorPrefixo(identifier);
        setTemIniciativasEtapa1((iniciativas?.length || 0) > 0);
      } catch {
        // best-effort
      }
    }
    if (isEtapaUmVotacaoAtiva && isElegivelEtapa1) {
      checkEtapa1Completion();
    }
  }, [isEtapaUmVotacaoAtiva, isElegivelEtapa1, user]);

  useEffect(() => {
    if (comunicados.length > 0 && comunicados[0].steps.length > 1) {
      const startInterval = () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }

        if (!isCarouselPaused) {
          intervalRef.current = setInterval(() => {
            setStepAtivo((prev) => {
              const totalSteps = comunicados[0].steps.length;
              return (prev + 1) % totalSteps;
            });
          }, 5000);
        }
      };

      startInterval();

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [comunicados, isCarouselPaused]);

  if (!user) return null;

  const handleOpenOnboarding = () => {
    if (tutorial && tutorial.steps.length > 0) {
      showModal(
        'onboarding-modal',
        <OnboardingModal
          steps={tutorial.steps}
          onClose={closeModal}
        />,
        'onboarding-modal-wrapper',
        false
      );
    } else {
      console.warn('Tutorial não disponível');
    }
  };

  const getUserData = () => ({
    nome: user.extra?.nome_guerra || user.detail?.nome_guerra || user.detail?.nome || user.name || 'Usuário',
    primeiraLetra: user.name?.charAt(0).toUpperCase() || 'U',
    foto: user.image?.small?.url
  });

  const handleGoToEtapaUmVotacao = () => {
    navigate('/votacao-etapa-1');
  };

  const handleGoToEtapaDoisVotacao = () => {
    if (!isEtapaDoisVotacaoAtiva) return;
    navigate('/votacao-etapa-2');
  };

  const handleGoToEtapaTresVotacao = () => {
    navigate('/votacao-etapa-3');
  };

  const handleGoToMeusVotosEtapa3 = () => {
    navigate('/meus-votos-etapa-3');
  };

  const abrirTutorialEtapa3 = () => {
    if (!isEtapaTresVotacaoAtiva) return;
    if (!tutorialEtapa3?.steps?.length) {
      handleGoToEtapaTresVotacao();
      return;
    }
    showModal(
      'votacao-etapa3-tutorial-modal',
      <VotacaoEtapa3TutorialModal
        steps={tutorialEtapa3.steps}
        onClose={closeModal}
        onStartVoting={() => {
          closeModal();
          handleGoToEtapaTresVotacao();
        }}
      />,
      'votacao-etapa3-tutorial-wrapper',
      false
    );
  };

  const abrirTutorialEtapa2 = () => {
    if (!isEtapaDoisVotacaoAtiva) return;
    if (!tutorialEtapa2?.steps?.length) {
      handleGoToEtapaDoisVotacao();
      return;
    }
    showModal(
      'votacao-etapa2-tutorial-modal',
      <VotacaoEtapa2TutorialModal
        steps={tutorialEtapa2.steps}
        onClose={closeModal}
        onStartVoting={() => {
          closeModal();
          handleGoToEtapaDoisVotacao();
        }}
      />,
      'votacao-etapa2-tutorial-wrapper',
      false
    );
  };

  const handleOpenVotingTutorial = (event?: MouseEvent<HTMLElement>) => {
    event?.stopPropagation();
    if (!tutorialEtapa1?.steps?.length) {
      console.warn('Tutorial Etapa 1 não disponível');
      return;
    }
    showModal(
      'votacao-etapa1-tutorial-modal',
      <VotacaoEtapa1TutorialModal
        steps={tutorialEtapa1.steps}
        onClose={closeModal}
        onStartVoting={() => {
          closeModal();
          navigate('/votacao-etapa-1');
        }}
      />,
      'votacao-etapa1-tutorial-wrapper',
      false
    );
  };

  const handlePrevStep = () => {
    setStepAtivo((prev) => {
      const totalSteps = comunicados[0].steps.length;
      return prev === 0 ? totalSteps - 1 : prev - 1;
    });
  };

  const handleNextStep = () => {
    setStepAtivo((prev) => {
      const totalSteps = comunicados[0].steps.length;
      return (prev + 1) % totalSteps;
    });
  };

  return (
    <div id="home-elbb-wrapper">
      <HeaderElbb currentPage="inicio" highlightMinhaJornada />

     {/* <ExtratoNotificationPopupElbb
        open={extratoPopupOpen}
        onClose={() => setExtratoPopupOpen(false)}
      /> */}

      <HeroElbb
        user={getUserData()}
        badges={loadingBadges ? [] : badges}
        isParticipanteConfirmado={isParticipanteConfirmado}
        hasConquistaVotar={hasConquistaVotar}
        ilustracao={naveEspacial}
        onOpenOnboarding={handleOpenOnboarding}
      />

      <main className="home-elbb-main">
        <PremiadosBannerElbb />

              {/* 
                BANNERS CONDICIONAIS - Comentados para testes visuais
                Descomentar e remover banner fixo abaixo quando feature estiver pronta para produção
                
                Condição 1: Quando usuário completou análise de todas as categorias da Etapa 2
                {isEtapaDoiVotacaoAtiva && isElegivelEtapa1 && temIniciativasEtapa2 && todasCategoriasEtapa2Completas && (
                  <section className="notification-banner notification-banner--votacao">
                    <div
                      className="notification-banner__content notification-banner__content--clickable"
                      onClick={() => navigate('/meus-votos-etapa-2')}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          navigate('/meus-votos-etapa-2');
                        }
                      }}
                    >
                      <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
                      <p className="notification-banner__text">
                        A seleção de iniciativas da Etapa 2 do Prêmio ELBB já foi concluída para o seu comitê.
                      </p>
                      <button
                        className="notification-banner__btn"
                        onClick={(event) => { event.stopPropagation(); navigate('/meus-votos-etapa-2'); }}
                      >
                        INICIAR VOTAÇÃO!
                      </button>
                    </div>
                  </section>
                )}

                Condição 2: Quando usuário ainda precisa completar análise de categorias da Etapa 2
                {isEtapaDoiVotacaoAtiva && isElegivelEtapa1 && temIniciativasEtapa2 && !todasCategoriasEtapa2Completas && (
                  <section className="notification-banner notification-banner--votacao">
                    <div
                      className="notification-banner__content notification-banner__content--clickable"
                      onClick={handleGoToEtapaDoiVotacao}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          handleGoToEtapaDoiVotacao();
                        }
                      }}
                    >
                      <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
                      <p className="notification-banner__text">
                        Você faz parte do comitê que analisa as iniciativas na Etapa 2 do Prêmio ELBB.
                      </p>
                      <button
                        className="notification-banner__btn"
                        onClick={(event) => { event.stopPropagation(); handleGoToEtapaDoiVotacao(); }}
                      >
                        INICIAR VOTAÇÃO!
                      </button>
                    </div>
                  </section>
                )}
              */}

              {/* Banner fixo para testes visuais - Remover quando voltar a usar banners condicionais */}
              {/*
              <section className="notification-banner notification-banner--votacao">
                <div
                  className="notification-banner__content notification-banner__content--clickable"
                  onClick={() => navigate('/votacao-etapa-2')}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      navigate('/votacao-etapa-2');
                    }
                  }}
                >
                  <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
                  <p className="notification-banner__text">
                    Você faz parte da banca técnica da categoria Joga Junto! A votação da Etapa 2 acontece de 13/04 a 01/05.
                  </p>
                  <button
                    className="notification-banner__btn"
                    onClick={(event) => { event.stopPropagation(); navigate('/votacao-etapa-2'); }}
                  >
                    INICIAR VOTAÇÃO!
                  </button>
                </div>
              </section>
              */}

        {user?.extra?.etapa === 2 && isEtapaDoisVotacaoAtiva && user?.extra?.categories?.includes('ELBB') && (
          <section className="notification-banner notification-banner--votacao">
            <div
              className="notification-banner__content notification-banner__content--clickable"
              onClick={handleGoToEtapaDoisVotacao}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleGoToEtapaDoisVotacao();
                }
              }}
            >
              <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
              {jaVotouTodasCategoriasEtapa2 ? (
                <p className="notification-banner__text">
                  Sua avaliação da Etapa 2 foi enviada. Confira aqui suas notas.
                </p>
              ) : (
                <p className="notification-banner__text">
                  Você faz parte da banca técnica que avalia as iniciativas na Etapa 2 do Prêmio ELBB.
                  {datasEtapa2Label && ` A votação da Etapa 2 acontece de ${datasEtapa2Label}.`}{' '}
                  <button
                    className="notification-banner__link"
                    onClick={(event) => {
                      event.stopPropagation();
                      abrirTutorialEtapa2();
                    }}
                  >
                    Saiba aqui como votar!
                  </button>
                </p>
              )}
              <button
                className="notification-banner__btn"
                onClick={(event) => {
                  event.stopPropagation();
                  handleGoToEtapaDoisVotacao();
                }}
              >
                {jaVotouTodasCategoriasEtapa2 ? 'VER AVALIAÇÃO' : 'INICIAR VOTAÇÃO!'}
              </button>
            </div>
          </section>
        )}

        {/* Banner Etapa 3 — banca (extra.etapa === 3) */}
        {Number(user?.extra?.etapa) === 3 && (isEtapaTresVotacaoAtiva || jaVotouTodasCategoriasEtapa3) && (
          <section className="notification-banner notification-banner--votacao">
            <div
              className="notification-banner__content notification-banner__content--clickable"
              onClick={jaVotouTodasCategoriasEtapa3 ? handleGoToMeusVotosEtapa3 : handleGoToEtapaTresVotacao}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  jaVotouTodasCategoriasEtapa3 ? handleGoToMeusVotosEtapa3() : handleGoToEtapaTresVotacao();
                }
              }}
            >
              <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
              {jaVotouTodasCategoriasEtapa3 ? (
                <p className="notification-banner__text">
                  Seu voto foi registrado. Veja as iniciativas que você selecionou na Etapa 3.
                </p>
              ) : isAssessor ? (
                <p className="notification-banner__text">
                  {assessorPreliminarSuperseded
                    ? 'O voto final da Etapa 3 já foi enviado pelo seu Vice-Presidente.'
                    : assessorEnviouPreliminar
                    ? 'Voto preliminar enviado — aguardando a revisão do Vice-Presidente.'
                    : 'Você prepara o voto preliminar da Etapa 3 do Prêmio ELBB para o seu Vice-Presidente.'}{' '}
                  {!assessorJaEnviou && (
                    <button
                      className="notification-banner__link"
                      onClick={(event) => {
                        event.stopPropagation();
                        abrirTutorialEtapa3();
                      }}
                    >
                      Saiba aqui como votar!
                    </button>
                  )}
                </p>
              ) : (
                <p className="notification-banner__text">
                  {isVp && vpTemPreliminarPendente
                    ? 'Seu assessor preparou um voto preliminar para a sua revisão.'
                    : 'Você faz parte da banca avaliadora da Etapa 3 do Prêmio ELBB.'}{' '}
                  <button
                    className="notification-banner__link"
                    onClick={(event) => {
                      event.stopPropagation();
                      abrirTutorialEtapa3();
                    }}
                  >
                    Saiba aqui como votar!
                  </button>
                </p>
              )}
              <button
                className="notification-banner__btn"
                onClick={(event) => {
                  event.stopPropagation();
                  if (assessorJaEnviou) {
                    handleGoToEtapaTresVotacao();
                  } else if (jaVotouTodasCategoriasEtapa3) {
                    handleGoToMeusVotosEtapa3();
                  } else {
                    handleGoToEtapaTresVotacao();
                  }
                }}
              >
                {assessorJaEnviou
                  ? 'VER VOTO PRELIMINAR'
                  : jaVotouTodasCategoriasEtapa3
                  ? 'VER MEUS VOTOS'
                  : 'INICIAR VOTAÇÃO'}
              </button>
            </div>
          </section>
        )}

        {/* Seção "Conheça as iniciativas classificadas na Etapa 1" — visível durante Etapa 2 */}
        {isEtapaDoisVotacaoAtiva && (
          <>
            <div className="categorias-participantes-wrapper">
              <CategoriasParticipantes />
            </div>

            <section className="iniciativas-section-elbb" aria-labelledby="iniciativas-title-elbb">
              <div className="iniciativas-section-elbb__content">
                <button
                  className="btn-ver-todas-elbb"
                  onClick={() => navigate('/classificadas-etapa-1-elbb')}
                  aria-label="Ver todas as iniciativas classificadas na Etapa 1 do ELBB"
                >
                  VER TODAS AS INICIATIVAS
                </button>
              </div>
            </section>
          </>
        )}

        {false && (
          <section className="iniciativas-section iniciativas-section--etapa3">
            <div className="iniciativas-section__content">
              <img
                src={trofeuEtapa3}
                alt=""
                aria-hidden="true"
                className="iniciativas-section__trofeu"
              />
              {/*
              <div className="iniciativas-section__etapa3-body">
                <h2 className="iniciativas-section__etapa3-title">
                  Iniciativas finalistas que concorrem <br></br>ao <span className='text-green-bb-1'>Prêmio ELBB</span>
                </h2>
                <div className="iniciativas-section__etapa3-actions">
                  {(assessorJaEnviou || temVotoEtapa3Submetido || isEtapaTresVotacaoAtiva) && (
                    <button
                      type="button"
                      className="btn-ver-todas"
                      onClick={
                        assessorJaEnviou
                          ? handleGoToEtapaTresVotacao
                          : temVotoEtapa3Submetido
                          ? handleGoToMeusVotosEtapa3
                          : handleGoToEtapaTresVotacao
                      }
                    >
                      {assessorJaEnviou
                        ? 'VER VOTO PRELIMINAR'
                        : temVotoEtapa3Submetido
                        ? 'VER MEUS VOTOS'
                        : 'INICIAR VOTAÇÃO'}
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn-ver-todas"
                    onClick={() => navigate('/indicados-elbb')}
                  >
                    CONHEÇA OS INDICADOS
                  </button>
                  {isEtapaTresVotacaoAtiva && (
                    <button
                      type="button"
                      className="iniciativas-section__tutorial-link"
                      onClick={abrirTutorialEtapa3}
                    >
                      Saiba aqui como votar!
                    </button>
                  )}
                </div>
              </div>
              */}
            </div>
          </section>
        )}

        {/*
        <section className="comunicados-section-elbb" aria-labelledby="comunicados-title-elbb">
          <h2 className="section-title-elbb" id="comunicados-title-elbb" tabIndex={0}>Comunicados</h2>
          <div className="comunicados-container-elbb">
            {loadingComunicados ? (
              <div className="flex justify-center items-center py-8" role="status" aria-live="polite">
                <span className="text-primary-elbb">Carregando comunicados...</span>
              </div>
            ) : comunicados.length > 0 && comunicados[0].steps.length > 0 ? (
              <div
                className="comunicado-carrossel-elbb"
                role="region"
                aria-roledescription="carrossel"
                aria-label={`Comunicados: exibindo ${stepAtivo + 1} de ${comunicados[0].steps.length}`}
                onMouseEnter={() => setIsCarouselPaused(true)}
                onMouseLeave={() => setIsCarouselPaused(false)}
                onFocus={() => setIsCarouselPaused(true)}
                onBlur={() => setIsCarouselPaused(false)}
              >
                <button
                  className="carousel-arrow-elbb carousel-arrow-elbb--prev"
                  onClick={handlePrevStep}
                  aria-label="Comunicado anterior"
                >
                  <IoChevronBack size={32} aria-hidden="true" />
                </button>

                {(() => {
                  const currentStep = comunicados[0].steps[stepAtivo];
                  return (
                    <ComunicadoBannerElbb
                      html={currentStep?.text || ''}
                    />
                  );
                })()}

                <button
                  className="carousel-arrow-elbb carousel-arrow-elbb--next"
                  onClick={handleNextStep}
                  aria-label="Próximo comunicado"
                >
                  <IoChevronForward size={32} aria-hidden="true" />
                </button>

                <div className="carousel-dots-elbb" role="tablist" aria-label="Navegar comunicados">
                  {comunicados[0].steps.map((_: any, index: number) => (
                    <button
                      key={index}
                      className={`carousel-dot-elbb ${index === stepAtivo ? 'active' : ''}`}
                      onClick={() => setStepAtivo(index)}
                      role="tab"
                      aria-selected={index === stepAtivo}
                      aria-label={`Ver comunicado ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="comunicado-carrossel-elbb">
                <p className="text-center text-gray-500 py-8" tabIndex={0}>Nenhum comunicado disponível no momento.</p>
              </div>
            )}

            <aside className="premio-card-elbb" aria-label="Prêmio BB">
              <div className="premio-card-elbb__inner">
                <p className="premio-card-elbb__subtitle" tabIndex={0}>Conheça também as iniciativas do</p>
                <div className="premio-card-elbb__logo">
                  <img src={premioElbb} alt="Prêmio BB" tabIndex={0} />
                </div>
                <button
                  className="premio-card-elbb__button"
                  onClick={() => navigate('/home-public')}
                  aria-label="Quero conhecer o Prêmio BB"
                >
                  QUERO CONHECER!
                </button>
              </div>
            </aside>
          </div>
        </section>
        */}

        {/* Fase de premiação — ordem espelha a HomePublic: pódio dos vencedores,
            premiações disponíveis e galeria. */}
        <section className="iniciativas-section-elbb iniciativas-section-elbb--podio" aria-label="Pódio das iniciativas vencedoras ELBB">
          <h2 className="section-title-elbb" tabIndex={0}>
            Conheça as iniciativas vencedoras
          </h2>
          <PodioElbb />
        </section>

        <PremiacoesSectionElbb />

        {/* Galeria desativada temporariamente (não usada no momento) */}
        {/* <GaleriaPremioElbb /> */}

        <section className="cta-section-elbb" aria-label="Ações rápidas">
          <button
            className="cta-card-elbb cta-card-elbb--yellow"
            onClick={() => navigate('/iniciativas-elbb')}
            aria-label="Explorar iniciativas: conheça as iniciativas inspiradoras"
          >
            <div className="cta-card-elbb__content">
              <h3 className="cta-card-elbb__title">Explorar iniciativas</h3>
              <p className="cta-card-elbb__subtitle">Conheça as iniciativas inspiradoras</p>
            </div>
            <span className="cta-card-elbb__btn" aria-hidden="true">
              <IoArrowForward size={28} />
            </span>
          </button>
          <button
            className="cta-card-elbb cta-card-elbb--pink"
            onClick={() => navigate('/minha-jornada-elbb')}
            aria-label="Minha jornada: complete desafios e ganhe badges"
          >
            <div className="cta-card-elbb__content">
              <h3 className="cta-card-elbb__title">Minha jornada</h3>
              <p className="cta-card-elbb__subtitle">Complete desafios e ganhe badges</p>
            </div>
            <span className="cta-card-elbb__btn" aria-hidden="true">
              <IoArrowForward size={28} />
            </span>
          </button>
        </section>

        <section id="badges" className="badges-section-elbb" aria-labelledby="badges-title-elbb">
          <h2 className="section-title-elbb" id="badges-title-elbb" tabIndex={0}>Coleção de badges</h2>
          {loadingBadges ? (
            <div className="flex justify-center items-center py-8">
              <span className="text-primary-elbb">Carregando badges...</span>
            </div>
          ) : (
            <div className="badges-container-elbb">
              <div className="badges-grid-elbb" role="list" aria-label="Coleção de badges">
                {badges.map((badge) => (
                  <div
                    key={badge.id}
                    className={`badge-item-elbb ${badge.conquistado ? 'conquistado' : 'bloqueado'}`}
                    role="listitem"
                    tabIndex={0}
                    aria-label={`Badge: ${badge.nome}. ${badge.conquistado ? 'Conquistado' : 'Não conquistado'}`}
                  >
                    {badge.conquistado && <span className="badge-check-elbb" aria-hidden="true">✓</span>}
                    <img src={badge.imagem} alt="" aria-hidden="true" className="badge-image-elbb" />
                    <p className="badge-nome-elbb" tabIndex={0}>{badge.nome}</p>
                  </div>
                ))}
              </div>
              <button className="btn-ver-todos-elbb" onClick={() => navigate('/minha-jornada-elbb#badges')} aria-label="Ver todos os badges">VER TODOS</button>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
